import { Box, Paper, Tooltip, useTheme } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Typography from "components/basic/typography";

interface StatTileProps {
  label: string;
  value: string;
  /** Small qualifier under the number, e.g. a conversion rate. */
  detail?: string;
  /** Renders an info affordance — use it where the number needs a caveat. */
  hint?: string;
}

/**
 * A single headline number. No plot, so no hover layer beyond the optional
 * caveat tooltip.
 */
const StatTile: React.FC<StatTileProps> = ({ label, value, detail, hint }) => {
  const theme = useTheme();

  // No height: 100% — the grid already stretches items to the row, and
  // combining the two overflows the row and laps the panel below.
  return (
    <Paper variant="outlined" sx={{ padding: 2, borderRadius: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {label}
        </Typography>
        {hint && (
          <Tooltip title={hint} arrow>
            <InfoOutlinedIcon
              fontSize="inherit"
              sx={{ color: theme.palette.text.secondary, cursor: "help" }}
            />
          </Tooltip>
        )}
      </Box>

      <Typography variant="h4" style={{ fontWeight: 700, marginTop: 4 }}>
        {value}
      </Typography>

      {detail && (
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {detail}
        </Typography>
      )}
    </Paper>
  );
};

export default StatTile;
